type ConsentCategory = "analytics" | "marketing"

type ZarazCookie = {
  mioi: boolean // marketing
  jgzP: boolean // analytics
}

type ConsentResult = {
  success: boolean
  error?: string
}

type AllConsents = {
  analytics: boolean
  marketing: boolean
  error?: string
}

function getCookieValue(name: string): string | undefined {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(";").shift()
  return undefined
}

/**
 * Get consent status for a specific category
 */
export function getCookieConsent(category: ConsentCategory): ConsentResult {
  try {
    const consent = getCookieValue("zaraz-consent")

    if (!consent) {
      return { success: false, error: "No consent data found" }
    }

    const parsedConsent = JSON.parse(decodeURIComponent(consent)) as ZarazCookie

    return {
      success:
        category === "analytics" ? parsedConsent.jgzP : parsedConsent.mioi,
    }
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    }
  }
}

/**
 * Get all cookie consent statuses
 */
export function getAllCookieConsents(): AllConsents {
  try {
    const consent = getCookieValue("zaraz-consent")
    if (!consent) {
      return {
        analytics: false,
        marketing: false,
        error: "No consent data found",
      }
    }

    const parsedConsent = JSON.parse(decodeURIComponent(consent)) as ZarazCookie

    return {
      analytics: parsedConsent.jgzP,
      marketing: parsedConsent.mioi,
    }
  } catch (error) {
    return {
      analytics: false,
      marketing: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    }
  }
}
